import Login from './Login.vue'

export default Login



// WEBPACK FOOTER //
// ./client/masteradmin/pages/Login/index.js